<mat-card class="credit-cap-container pt-6">
  <h1 class="text-xl font-bold text-primary-main mb-1">
    {{ "wallet.creditCap" | translate }}
  </h1>

  <form class="mt-4" [formGroup]="form" preventFormSubmit>
    <app-input
      labelKey="wallet.amount"
      formControlName="credit_cap"
      onlyNumbers
      [isFloatNumber]="true"
      commasSeparateNumbers
      [formGroup]="form"
    ></app-input>

    <div class="flex w-full justify-end gap-2 mt-4">
      <app-button
        variant="outlined"
        color="primary-main"
        type="button"
        size="large"
        (click)="cancel()"
      >
        {{ "close" | translate }}
      </app-button>

      <app-button
        variant="filled"
        color="primary-main"
        type="submit"
        size="large"
        (click)="submit()"
        [disabled]="!form.dirty || isLoading"
        [isLoading]="isLoading"
      >
        {{ "submit" | translate }}
      </app-button>
    </div>
  </form>
</mat-card>
